export default __webpack_public_path__ + "static/media/planticon_6.47d11064.png";